/**
 * Container for the Dictate button.
 *
 * Reads dictation status from reactive variable and derives
 * button visibility and disabled state.
 * @module features/voice-report/components/DictateButton/DictateButtonContainer
 */

import { useReactiveVar } from "@apollo/client";
import React, { memo, useMemo } from "react";

import DictateButtonView from "./DictateButtonView";

import { dictationStatusVar } from "@/features/voice-report/stores/dictationStore";

/**
 * Props for DictateButtonContainer
 */
interface DictateButtonContainerProps {
  /** Called when Dictate is pressed to start recording */
  readonly onPress: () => void;
}

/**
 * Container for the Dictate button.
 * @param props - Component props
 * @param props.onPress - Start dictation handler
 */
const DictateButtonContainer = ({ onPress }: DictateButtonContainerProps) => {
  // 1. VARIABLES & STATE
  const status = useReactiveVar(dictationStatusVar);

  const isCompleted = status === "completed";
  const isHidden = useMemo(
    () => status === "recording" || status === "processing",
    [status]
  );

  // 2. NO SIDE EFFECTS

  // 3. RETURN
  return (
    <DictateButtonView
      onPress={onPress}
      isCompleted={isCompleted}
      isHidden={isHidden}
    />
  );
};

export default memo(DictateButtonContainer);
